import React from "react";
import { observer, inject } from "mobx-react";
import ratingFullText from "Texts/rating";
import { ModalLayout } from "ComponentsUI/Modallayout";

@inject("ApplicationModel")
@observer
export default class HowCalcRatingContainer extends React.Component {
	onClickHandler() {
		const modalModel = this.props.ApplicationModel.modalModel;
		const text = this.props.ApplicationModel.text;
		const windowSizeModel = this.props.ApplicationModel.windowSizeModel;

		import("ComponentsUI/News").then((News) => {
			modalModel.toggleModal(
				<ModalLayout
					closeModal={() => this.closeModal()}
					newsView={true}
					fullCloseElement={true}
					onlyDesktopCloseElement={true}
					closeOnClickLayout={true}
				>
					<News.FullNewsItem
						toggleWindow={() => this.closeModal()}
						windowSizes={windowSizeModel.windowSizes}
						typeB={true}
						texts={text}
						name={text.HOW_WE_CALCULATE_RATING}
						full_text={ratingFullText}
					/>
				</ModalLayout>
			);
		});
	}

	closeModal() {
		this.props.ApplicationModel.modalModel.toggleModal();
	}

	render() {
		return React.cloneElement(this.props.children, {
			onClickQuestion: () => this.onClickHandler(),
		});
	}
}
